import ReactDOM from 'react-dom';
import {ReactComponent as CloseIcon} from "../../assets/systemIcons/ic_close.svg";
import "./PopUp.css";

const PopUp = ({ title, subtitle, children, footer, isOpen, onClose, headerColor, backgroundColor, size="md", highPriority, textAlign = "center", divider }) => {
    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className={`PopUp__container${highPriority ? ' PopUp__container--highPriority' : ''}`}>
            <div className={`PopUp__content --${backgroundColor} --${size} --align-${textAlign}`}>
                {onClose && <button className={`PopUp__closeButton --${headerColor}`} onClick={onClose}>
                    <CloseIcon className="pcmodal__icon"/>
                </button>}
                <header className={`PopUp__header --${headerColor}`}>
                    <h2 className={`PopUp__title  ${divider && "--divider"}`}>{title}</h2>
                    {subtitle && <h3 className="PopUp__subtitle">{subtitle}</h3>}
                </header>
                <div className="PopUp__body">
                    {children}
                </div>
                <div className="PopUp__footer">
                    {footer}
                </div>
            </div>
        </div>
        , document.getElementById('portal-root'));

}

export default PopUp;